module.exports = {"views.checkoutSuccessMeditationStudio.success.heading":"Success!","views.checkoutSuccessMeditationStudio.success.body":"Your subscription has been successfully activated."}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en/views/CheckoutSuccessMeditationStudio.json
// module id = 715
// module chunks = 0